import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppThemeProvider from './styles/theme/AppThemeProvider';
import { AuthProvider } from './contexts/AuthContext';
import { PushProvider } from './contexts/PushContext';
import MobileRoutes from './MobileRoutes';
import DashboardRoutes from './DashboardRoutes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
});

const isDashboard = window.location.pathname.startsWith('/dashboard');

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider surface={isDashboard ? 'dashboard' : 'mobile'}>
        {isDashboard ? (
          <Router basename="/dashboard">
            <AuthProvider>
              <DashboardRoutes />
            </AuthProvider>
          </Router>
        ) : (
          <Router basename="/mobile">
            <AuthProvider>
              <PushProvider>
                <MobileRoutes />
              </PushProvider>
            </AuthProvider>
          </Router>
        )}
      </AppThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
